export const pickOverviewStore = ({
  groupBy,
  viewMode,
  flatOverview,
  consolidatedMetric,
}) =>
  groupBy === "metric" && viewMode === "consolidated"
    ? consolidatedMetric
    : flatOverview;

export const pickOrgDetailStore = ({
  viewMode,
  flatOrgDetail,
  consolidatedOrgDetail,
}) => (viewMode === "consolidated" ? consolidatedOrgDetail : flatOrgDetail);

export const syncOrgExpansionOnViewModeChange = ({
  next,
  current,
  flatOrgDetail,
  consolidatedOrgDetail,
}) => {
  if (next === current) return;
  const openKeys = Array.from(
    flatOrgDetail.expandedKeys.size > 0
      ? flatOrgDetail.expandedKeys
      : consolidatedOrgDetail.expandedKeys,
  );
  if (next === "consolidated") {
    flatOrgDetail.collapseAll();
    openKeys.forEach((orgId) => consolidatedOrgDetail.expand({ orgId }));
  } else {
    consolidatedOrgDetail.collapseAll();
    openKeys.forEach((orgId) => flatOrgDetail.expand({ orgId }));
  }
};
